// File: CarpenterRecordsSection.jsx
// Pure CSS | Dummy Icons | Screenshot used for reference layout

import React from 'react';
import { DollarSign, Donut, Goal, HeartPulse, House, Lightbulb, MapPinHouse, Mountain, MountainSnow, PenBox, PersonStanding, Rocket, Trophy } from 'lucide-react';

export default function AboutUsCard4() {
  return (<>
    <section className="cr-wrap">

      {/* LEFT SIDE - TESTIMONIAL */}
      <div className="cr-left">
        <div className="cr-quote-bg">“</div>

        <p className="cr-text">
          Te obtinuit ut adepto satis somno. Aliisque institoribus iter deliciae vivet vita.
          Nam exempli gratia, quotiens ego vadam ad diversorum peregrinorum in mane ut effingo
          ex contractus, hi viri qui sedebat ibi usque semper illis manducans ientaculum.
          Solum cum bulla ut debui; EGO youd adepto a macula proiciendi.
        </p>

        <div className="cr-author">
          <img src="https://i.pravatar.cc/90?img=12" alt="person" />
          <div>
            <div className="name">James Deans</div>
            <div className="role">Co-Founder</div>
          </div>
        </div>

        <div className="cr-dots">
          <span></span><span></span><span></span>
        </div>
      </div>


      {/* RIGHT SIDE - RECORDS */}
      <div className="cr-right">
        <div className="cr-icon-title"><Goal size={40} color={`rgba(144, 202, 249,1)`} /></div>
        <h2>OUR RECORDS</h2>
        <div className="cr-line"></div>

        <p className="cr-subtext">
          Te obtinuit ut adepto satis somno. Aliisque institutoribus iter deliciae vivet.
        </p>

        <div className="cr-record-grid">
          <div className="rec-item">
            <div className="ricon"><PersonStanding size={40} color={`rgba(144, 202, 249,1)`} /></div>
            <div className="num">786</div>
            <div className="label">HAPPY CLIENTS</div>
          </div>

          <div className="rec-item">
            <div className="ricon"><Trophy size={40} color={`rgba(144, 202, 249,1)`} /></div>
            <div className="num">69</div>
            <div className="label">AWARDS</div>
          </div>

          <div className="rec-item">
            <div className="ricon"><Rocket size={40} color={`rgba(144, 202, 249,1)`} />
            </div>
            <div className="num">1250</div>
            <div className="label">PROJECT DONE</div>
          </div>

          <div className="rec-item">
            <div className="ricon"><PenBox size={40} color={`rgba(144, 202, 249,1)`} /></div>
            <div className="num">12</div>
            <div className="label">YEARS EXPERIENCE</div>
          </div>
        </div>
      </div>

    </section>
    <style>{`
/* File: CarpenterRecordsSection.css */

.cr-wrap {
  display: flex;margin-top:50px;
  padding: 60px 40px;padding-top:0px;padding-bottom:0px;
  background: #f6f6f6;
  gap: 40px;
}

/* LEFT */
.cr-left {
  flex: 0.5;
  position: relative;
  padding: 20px 10px 20px 40px;
}

.cr-quote-bg {
  font-size: 340px;
  color: rgba(144, 202, 249,0.31);
  position: absolute;
  top: -10px;
  left: 20px;
  font-weight: 700;
}

.cr-text {
  font-size: 15px;
  line-height: 1.7;
  color: #444;
  max-width: 500px;
}

.cr-author {
  display: flex;
  align-items: center;
  margin-top: 22px;
  gap: 14px;
}

.cr-author img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}

.name {
  font-size: 18px;
  font-weight: 700;
  color: rgba(144, 202, 249,1);
}

.role {
  color: #666;
  font-size: 14px;
}

.cr-dots {
  margin-top: 18px;
  display: flex;
  gap: 8px;
}

.cr-dots span {
  width: 10px;
  height: 10px;
  background: #bbb;
  border-radius: 50%;
}

.cr-dots span:nth-child(2) { background: #000; }


/* RIGHT */
.cr-right {
  flex: 1;
  padding: 20px 20px 20px 40px;
  background: rgba(144, 202, 249,0.21);;
}

.cr-icon-title {
  font-size: 40px;
  color: rgba(144, 202, 249,1);
  margin-bottom: 8px;
}

.cr-right h2 {
  font-size: 30px;
  margin: 0;
  font-weight: 800;
}

.cr-line {
  width: 50px;
  height: 4px;
  background: rgba(144, 202, 249,1);
  margin: 14px 0 18px;
}

.cr-subtext {
  color: #555;
  margin-bottom: 30px;
  max-width: 400px;
}

.cr-record-grid {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.rec-item {
  text-align: center;
}

.ricon {
  font-size: 46px;
  color: rgba(144, 202, 249,1);
}

.num {
  font-size: 34px;
  font-weight: 700;
  margin-top: 6px;
}

.label {
  font-size: 13px;
  margin-top: 6px;
  letter-spacing: 0.5px;
  color: #444;
}

/* Responsive */
@media (max-width: 960px) {
  .cr-wrap { flex-direction: column; }
  .cr-record-grid { flex-wrap: wrap; }
  .cr-wrap {
 
  padding: 60px 0px;padding-top:0px;padding-bottom:0px;
  background: #f6f6f6;
  gap: 40px;
}
}`}</style>
    </>
  );
}
